var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Inject, Vue } from 'vue-property-decorator';
import { INJECT_UICORE_DESIGNER } from "../../../lib/utils/consts";
import { minBy } from "lodash-es";
let ZoomFitState = class ZoomFitState extends Vue {
  constructor() {
    super(...arguments);
    /** 编辑器底部是否留出空间 */
    this.editZoneBottomMargin = true;
    /** 记录着每个compPath的缩放状态 */
    this.fitStatusList = {};
    // 当前选中的组件路径
    this.currentCompPath = '';
    /** 退出作用域时是否进行自动缩放 */
    this.autoZoomBack = true;
  }
  /** 清除当前scope的缩放信息 */
  resetFitStatus() {
    Object.keys(this.fitStatusList).forEach(key => {
      this.$delete(this.fitStatusList, key);
    });
  }
  syncPageWidth(newWidth) {
    Object.values(this.fitStatusList).forEach(value => {
      const {
        unfitInfo
      } = value;
      unfitInfo && (unfitInfo.pageWidth = newWidth);
    });
  }
  preventAutoZoomBack() {
    this.autoZoomBack = false;
  }
  // 在designer的mounted时执行
  created() {
    this.$watch(() => this.designer.scopeStack.length, (n, old) => {
      if (n < old && this.autoZoomBack) {
        // 是退出作用域!
        // 判断是否要进行zoom back
        // 可能进行了好多次缩放 那就找缩放等级最小的原状态吧
        // TODO: 在compPath改版后 要找到当前作用域下的缩放最小原状态
        const minZoomStatus = minBy(Object.values(this.fitStatusList).filter(value => value.status === 'fit' && value.unfitInfo),
        // 必须是手动点过＋🔍进行缩放了 才纳入zoom back范围
        // 必须是手动点过＋🔍进行缩放了 才纳入zoom back范围
        fitStatus => {
          var _fitStatus$unfitInfo;
          return (_fitStatus$unfitInfo = fitStatus.unfitInfo) === null || _fitStatus$unfitInfo === void 0 ? void 0 : _fitStatus$unfitInfo.zoom;
        });
        if (minZoomStatus) {
          this.zoomBack(minZoomStatus);
        }
      }
      // TODO: 在compPath改版后仅清除已退出的作用域路径
      // 重置所有的缩放信息
      this.resetFitStatus();
      // 作用域变更后 默认可以进行自动zoomback操作
      this.autoZoomBack = true;
    });
    // 在用户进行缩放后 退出作用域时不执行自动缩放
    this.designer.$on('zoom-changed-user', this.preventAutoZoomBack);
    // 用户调整页宽后 退出作用域时不执行自动缩放 并且手动zoomback时 页宽设置失效
    this.designer.$on('pageWidth-changed-user', this.preventAutoZoomBack);
    this.designer.$on('pageWidth-changed-user', this.syncPageWidth);
    this.$watch(() => this.designer.zoom, () => {
      // 原始缩放大于当前缩放的全都扔掉!
      Object.entries(this.fitStatusList)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .filter(([key, value]) => value.unfitInfo && value.unfitInfo.zoom > this.designer.zoom).forEach(([key, value]) => {
        if (key === this.currentCompPath) {
          value.status = 'unfit';
        } else {
          this.$delete(this.fitStatusList, key);
        }
      });
    });
  }
  beforeDestroy() {
    this.designer.$off('zoom-changed-user', this.preventAutoZoomBack);
    this.designer.$off('pageWidth-changed-user', this.preventAutoZoomBack);
    this.designer.$off('pageWidth-changed-user', this.syncPageWidth);
  }
  /** actionbar生成时返回🔍按钮 */
  get compAction() {
    // fitStatus.status触发计算属性 从而改变compactionbar的图标
    const compPath = this.currentCompPath;
    let fitStatus = this.fitStatusList[compPath];
    if (!fitStatus) {
      fitStatus = {
        status: 'unfit',
        unfitInfo: null
      };
      this.$set(this.fitStatusList, compPath, fitStatus);
    }
    return {
      title: '',
      desc: '缩放至窗口',
      icon: fitStatus.status === 'unfit' ? 'fa fa-search-plus' : 'fa fa-search-minus',
      execute: this.getFitCallBack(compPath)
    };
  }
  /** 点击缩放按钮时执行callback */
  getFitCallBack(compPath) {
    return () => {
      // 生成fitcallback之前一定经过了默认值生成 不会为undefined
      const fitStatus = this.fitStatusList[compPath];
      if (fitStatus.status === 'unfit') {
        // 采集放大前的缩放信息
        fitStatus.unfitInfo = this.getUnfitInfo();
        // 改造async?
        this.zoomFitWindow(compPath);
        fitStatus.status = 'fit';
      } else {
        // 复原
        fitStatus.status = 'unfit';
        this.zoomBack(fitStatus);
      }
    };
  }
  /** 用户按下 (-🔍) 或者退出作用域时 进行页面状态恢复 */
  zoomBack(fitStatus) {
    const {
      zoom,
      top,
      left,
      pageWidth
    } = fitStatus.unfitInfo;
    // 先恢复缩放和页宽 然后恢复滚动状态
    this.designer.zoom = zoom;
    this.designer.pageWidth = pageWidth;
    setTimeout(() => {
      const {
        editZone
      } = this.designer.editZoneState;
      editZone.$el.scrollTo({
        top,
        left,
        behavior: 'auto'
      });
    }, 0);
  }
  /** 保存缩放前的页面状态 */
  getUnfitInfo() {
    const {
      editZone
    } = this.designer.editZoneState;
    return {
      zoom: this.designer.zoom,
      top: editZone.$el.scrollTop,
      left: editZone.$el.scrollLeft,
      pageWidth: this.designer.pageWidth
    };
  }
  /** 计算element适配到editZone 100%所需的缩放比 */
  getFitZoom(element, editZone) {
    const rect = element.getBoundingClientRect();
    const editRect = editZone.$el.getBoundingClientRect();
    // rect.width / currentZoom *newZoom = editRect.width
    // 继续考虑8的canvaswrapper padding
    const widthZoom = (editRect.width - 8 * 2) / rect.width * this.designer.zoom;
    const heightZoom = (editRect.height - 8 * 2) / rect.height * this.designer.zoom;
    // 找到 最小的缩放 使插槽刚好不溢出屏幕
    // 小于100%的缩放可能会影响编辑器比例
    return [widthZoom, heightZoom].sort((a, b) => a - b).slice(0, 1).map(zoom => Math.floor(zoom))
    // 缩放如果小于40就放弃了
    .filter(zoom => zoom >= 40)[0];
  }
  /** 将指定的compPath组件 缩放至适配editZone的90%大小 */
  zoomFitWindow(compPath) {
    var _this$designer;
    const element = this === null || this === void 0 || (_this$designer = this.designer) === null || _this$designer === void 0 || (_this$designer = _this$designer.renderer) === null || _this$designer === void 0 || (_this$designer = _this$designer.getRefByPath(compPath)) === null || _this$designer === void 0 ? void 0 : _this$designer.$el;
    if (!element) return false;
    const {
      editZone
    } = this.designer.editZoneState;
    let zoomApply = this.getFitZoom(element, editZone);
    if (zoomApply) {
      // 在页宽auto模式下 当缩放小于100%时 页宽会随着缩放而改变 所以对页宽进行锁定
      const willChangeWidth = this.designer.pageWidth === 'auto' && (this.designer.zoom < 100 || zoomApply < 100);
      if (willChangeWidth) {
        var _editZone$$refs;
        const pageWidth = editZone === null || editZone === void 0 || (_editZone$$refs = editZone.$refs) === null || _editZone$$refs === void 0 || (_editZone$$refs = _editZone$$refs.rendererCanvas) === null || _editZone$$refs === void 0 ? void 0 : _editZone$$refs.offsetWidth;
        this.designer.pageWidth = pageWidth;
      }
      // 缩放窗口占总画布的90% 同时原本放大的操作 不能因为*0.9后变为缩小跨过100%
      if (zoomApply > 100) {
        zoomApply = Math.max(100, Math.ceil(zoomApply * 0.9));
      } else {
        zoomApply = Math.ceil(zoomApply * 0.9);
      }
      // 缩放等级限制到[40,300]
      zoomApply = Math.min(300, zoomApply);
      zoomApply = Math.max(40, zoomApply);
      this.designer.zoom = zoomApply;
      // 进行滚动使得组件尽可能处于屏幕中央
      const fixScroll = (behavior = 'auto') => {
        const editRect = editZone.$el.getBoundingClientRect();
        const rect = element.getBoundingClientRect();
        // 又是canvaswarpper的8 padding
        const deltaTop = rect.top - editRect.top - (editRect.height - 8 - rect.height) / 2;
        const deltaLeft = rect.left - editRect.left - (editRect.width - 8 - rect.width) / 2;
        editZone.$el.scrollTo({
          top: editZone.$el.scrollTop + deltaTop,
          left: editZone.$el.scrollLeft + deltaLeft,
          behavior
        });
      };
      this.$nextTick(fixScroll);
    }
  }
};
__decorate([Inject(INJECT_UICORE_DESIGNER)], ZoomFitState.prototype, "designer", void 0);
ZoomFitState = __decorate([Component({
  name: 'ZoomFitState'
})], ZoomFitState);
export default ZoomFitState;
//# sourceMappingURL=ZoomFitState.js.map
